import { FormName } from 'redux-form';
import PropTypes from 'prop-types';
import { constants } from '@eti/utils';
import { seatCharacteristics } from '../../utils/constants';
import BookableSeat from '../../containers/BookableSeatContainer';
import RowWrapper from './RowWrapper';
import Aisle from './Aisle';
import EmptySpace from './EmptySpace';
import Stairs from './Stairs';
import Toilet from './Toilet';
import UnavailableSeat from './UnavailableSeat';
import ExitArrow from './ExitArrow';
import { jsx as _jsx } from "react/jsx-runtime";
const renderRowItem = (activeSegment, activeTraveler, carrier, isChild, isEmptyRow, isExitRow, onChange) => (item, key) => {
  switch (item === null || item === void 0 ? void 0 : item.type) {
    case 'TOILET':
      return /*#__PURE__*/_jsx(Toilet, {}, `rowItem-${key}`);
    case 'STAIRS':
      return /*#__PURE__*/_jsx(Stairs, {}, `rowItem-${key}`);
    case 'AISLE':
      return /*#__PURE__*/_jsx(Aisle, {
        row: item.row
      }, `rowItem-${key}`);
    case 'EXIT_ARROW':
      return /*#__PURE__*/_jsx(ExitArrow, {
        direction: key === 0 ? ExitArrow.Direction.LEFT : ExitArrow.Direction.RIGHT
      }, `rowItem-${key}`);
    case 'NORMAL':
      return !item.isBookable || isExitRow && isChild ? /*#__PURE__*/_jsx(UnavailableSeat, {}, `rowItem-${key}`) : /*#__PURE__*/_jsx(FormName, {
        "data-testid": `rowItem-${key}`,
        children: _ref => {
          let {
            form
          } = _ref;
          return /*#__PURE__*/_jsx(BookableSeat, {
            activeSegment: activeSegment,
            activeTraveler: activeTraveler,
            carrier: carrier,
            form: form,
            onChange: onChange,
            ...item
          });
        }
      }, `rowItem-${key}`);
    default:
      return /*#__PURE__*/_jsx(EmptySpace, {
        exitRow: isEmptyRow
      }, `rowItem-${key}`);
  }
};
const RowContent = _ref2 => {
  let {
    activeSegment,
    activeTraveler,
    carrier,
    isEmptyRow,
    isExitRow,
    onChange,
    sellSeatMapSeats = [],
    travelers
  } = _ref2;
  const isChild = travelers === null || travelers === void 0 ? void 0 : travelers.find(traveler => traveler.ageType === constants.ageTypes.CHILD);
  return /*#__PURE__*/_jsx(RowWrapper, {
    children: sellSeatMapSeats.map(renderRowItem(activeSegment, activeTraveler, carrier, isChild, isEmptyRow, isExitRow, onChange))
  });
};
RowContent.propTypes = {
  activeSegment: PropTypes.string,
  activeTraveler: PropTypes.number,
  carrier: PropTypes.shape({
    code: PropTypes.string,
    name: PropTypes.string
  }),
  isEmptyRow: PropTypes.bool,
  isExitRow: PropTypes.bool,
  onChange: PropTypes.func,
  sellSeatMapSeats: PropTypes.arrayOf(PropTypes.shape({
    characteristics: PropTypes.arrayOf(PropTypes.oneOf(Object.values(seatCharacteristics))),
    column: PropTypes.string,
    isBookable: PropTypes.bool,
    mainCharacteristic: PropTypes.oneOf(Object.values(seatCharacteristics)),
    price: PropTypes.number,
    row: PropTypes.number,
    seat: PropTypes.string,
    type: PropTypes.string
  })),
  travelers: PropTypes.arrayOf(PropTypes.shape({
    ageType: PropTypes.string,
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    name: PropTypes.string
  }))
};
export default RowContent;
//# sourceMappingURL=RowContent.js.map